import { BuscaTermosPrivacidade } from '../api';

export interface PrivacyTermsState {
  terms: BuscaTermosPrivacidade | null;
}

export enum PrivacyTermsCommits {
  SET_TERMS = 'SET_TERMS',
}
